import {ReportBO} from "./ReportBO";
import _ = require("lodash");
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_ReportMetricRow} from "../PA.Core/PAdbSchemaRows";


export class ReportBOValidations {


    static ValidateFields(aBO: ReportBO): Promise<void> {
        const self = this;
        return new Promise((resolve, reject) => {

            //Validate Report ID
            ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(aBO.WB_Report.cif.REPORT_ID), "EmptyId", "Report Id cannot be empty");

            //Validate Report name
            ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(aBO.WB_Report.cif.REPORT_NAME), "EmptyName", "Report Name must be set");

            //Validate Sort Order for to be number
            ErrorMessage_restate(aBO.ValidateMessageProvider, !_.isNumber(_.toNumber(aBO.WB_Report.cif.SORT_ORDER)), "isNumber", "Number required for Report Sort Order.");

            _.forEach(aBO.WB_Report.WB_ReportMetricRows, (aReportMetricRow: WB_ReportMetricRow) => {
                //layout validation
                _.reduce(aReportMetricRow.cif.METRIC_LAYOUT_OPTIONS.split(","), (accumulator: string, current: string) => {
                    ErrorMessage_restate(aBO.ValidateMessageProvider, accumulator.startsWith("indent") === current.startsWith("indent"), "DuplicateOptions", "Duplicate Indent option selected.");
                    return current
                })

                ErrorMessage_restate(aBO.ValidateMessageProvider, !_.isNumber(_.toNumber(aReportMetricRow.cif.SORT_ORDER)), `isNumberLine-${aReportMetricRow.cif.WB_REPORTMETRICR_ID}`, "Number required for Report Line Sort Order.");
            });

            //validation for sortorder and ovrd
            let index = 0;
            _.reduce(_.orderBy(_.filter(aBO.WB_Report.WB_ReportMetricRows, aRow => aRow.isActive), 'SORT_ORDER'), (accumulator: WB_ReportMetricRow, current: WB_ReportMetricRow) => {
                if (accumulator.cif.SORT_ORDER === current.cif.SORT_ORDER) {
                    if (accumulator.cif.METRIC_NAME_OVRD !== current.cif.METRIC_NAME_OVRD) {
                        index++;
                    }
                }
                return current;
            });

            //Validate Sort Order for to be number
            ErrorMessage_restate(aBO.ValidateMessageProvider, index > 0, "Discrepancy", "Sort order and Name Ovrd have discrepancy.");

            // Validate the output levels are filled when Enable Extract is checked
            const bEnableExtract: boolean = aBO.WB_Report.cif.EXTRACT_IND === "1"
            const bIsMissingOutputLevel: boolean = aBO.WorkspaceReport.aggLevelCustomer === "" || aBO.WorkspaceReport.aggLevelProduct === "" || aBO.WorkspaceReport.aggLevelTime === "";
            ErrorMessage_restate(aBO.ValidateMessageProvider, bEnableExtract && bIsMissingOutputLevel, "MissingConfig", "Output levels must be set when Enable Extract is checked")

            resolve();
        })
    }

    static ValidateOnSelection(aBO: ReportBO, aItems: any): Promise<void> {
        const self = this;
        return new Promise((resolve, reject) => {

            _.reduce(aItems, (accumulator: any, current: any) => {
                ErrorMessage_restate(aBO.ValidateMessageProvider, accumulator.mProperties.key.startsWith("indent") === current.mProperties.key.startsWith("indent"), "DuplicateOptions", "Duplicate Indent option selected.");
                return current
            })
            resolve();
        });

    }

}
